import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface UIState {
  // Sidebar state
  sidebarOpen: boolean;
  
  // Dark mode state
  darkMode: boolean;
  
  // Loading states
  isLoading: boolean;
  loadingMessage?: string;
  
  // Actions
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleDarkMode: () => void;
  setDarkMode: (enabled: boolean) => void;
  setLoading: (loading: boolean, message?: string) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Initial state
      sidebarOpen: true,
      darkMode: false,
      isLoading: false,
      loadingMessage: undefined,
      
      // Actions
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
      toggleDarkMode: () => set((state) => ({ darkMode: !state.darkMode })),
      setDarkMode: (enabled: boolean) => set({ darkMode: enabled }),
      setLoading: (loading: boolean, message?: string) => 
        set({ isLoading: loading, loadingMessage: message }),
    }),
    {
      name: 'go2url-ui-state',
      storage: createJSONStorage(() => localStorage),
      // Only persist certain keys
      partialize: (state) => ({
        sidebarOpen: state.sidebarOpen,
        darkMode: state.darkMode,
      }),
    }
  )
);